import Loader from "../../components/Loader/Loader";

export const ExpensesTable = ({ loading, fundsData }) => {
  if (loading) {
    return <Loader text={"Fetching Funds"} />;
  }

  const currencySymbols = {
    USD: "$",
    CAD: "C$",
    INR: "₹",
    EUR: "€",
    GBP: "£",
  };

  const symbol = currencySymbols[fundsData.currency] || "";

  return (
    <div className="overflow-x-auto mb-6 rounded-lg">
      {fundsData.breakdown && fundsData.breakdown.length > 0 ? (
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-[#FFD4F4]">
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-black">
                Funds Parameter
              </th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-black">
                Individual Expenses ({fundsData.currency})
              </th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-black">
                Participants
              </th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-black">
                Total Expenses ({fundsData.currency})
              </th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-black">
                Total Expenses (INR)
              </th>
            </tr>
          </thead>
          <tbody>
            {fundsData.breakdown.map((row, index) => (
              <tr key={index}>
                {row.map((cell, cellIndex) => {
                  let value = cell;
                  if (cellIndex === 1 || cellIndex === 3) {
                    // replace any existing currency symbols and format dynamically
                    value = `${symbol}${cell
                      .toString()
                      .replace(/[^\d.,-]/g, "")}`;
                  }
                  return (
                    <td
                      key={cellIndex}
                      className="border border-gray-300 px-4 py-3 font-medium text-gray-700"
                    >
                      {value || "-"}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        ""
      )}
    </div>
  );
};
